import { PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';

export const providersWithoutSaveCCSupport: PaymentProvider[] = [
  PaymentProvider.Square,
  PaymentProvider.TwoCheckout,
];
